import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteProgram } from "../../services/program";
import { toast } from "react-toastify";

const useDeleteProgram = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteProgram,

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["categories"] });
                toast.success("Program deleted successfully");
            }
        },

        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteProgram;